import { useCanListMyTimesheets, useHasStaffTimesheets } from '@sit/client-shared';
import { useIsAuthenticated } from '@web/redux/hooks';
import { NavigateOptions, useNavigate } from 'react-router';

export function useNavigateHome() {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const mt = useCanListMyTimesheets({ enabled: isAuthenticated });
  const { data: st } = useHasStaffTimesheets({ enabled: isAuthenticated });
  if (mt) return (options?: NavigateOptions) => navigate('/timesheets', options);
  if (st) return (options?: NavigateOptions) => navigate('/staff-timesheets', options);
  return (options?: NavigateOptions) => navigate('/', options);
}

export function useNavigateBack() {
  const navigate = useNavigate();
  const navigateHome = useNavigateHome();
  const hasHistory: boolean = window.history.state && window.history.state.idx > 0;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  if (hasHistory) return (toFallback?: string, options?: NavigateOptions) => navigate(-1);
  return (toFallback?: string, options?: NavigateOptions) => (toFallback ? navigate(toFallback, options) : navigateHome(options));
}
